import { Reveal } from "@/components/site/Reveal";

const chapters = [
  {
    n: "01",
    title: "Skincare has no feedback loop.",
    body: "You apply serums for weeks with no way to know if they are working, reaching the skin, or if anything has changed at all. It is guesswork, sold at a premium.",
  },
  {
    n: "02",
    title: "So we closed the loop.",
    body: "ASYA reads your skin, personalizes the formulation, delivers it precisely, then measures the response — a single connected system that adapts to you instead of a shelf of bottles.",
  },
  {
    n: "03",
    title: "Skincare that proves itself.",
    body: "Eleven skin conditions classified by AI. Ingredients driven by data, not marketing. Results you can actually see, tracked day after day.",
  },
];

export const Manifesto = () => (
  <section className="relative py-28 md:py-40">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <Reveal>
        <p className="overline mb-16">The thesis</p>
      </Reveal>

      <div className="space-y-24 md:space-y-36">
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={0.05}>
            <div className="relative grid md:grid-cols-12 gap-6 md:gap-10 items-start">
              <span
                aria-hidden
                className="pointer-events-none absolute -top-16 md:-top-24 left-0 font-serif text-[28vw] md:text-[13vw] leading-none text-white/[0.04] select-none"
              >
                {c.n}
              </span>
              <div className="md:col-span-2 relative">
                <span className="font-mono text-sm text-primary">{c.n}</span>
              </div>
              <h3 className="md:col-span-6 relative font-serif font-light text-4xl md:text-6xl leading-[1.02] tracking-[-0.02em] text-balance">
                {c.title}
              </h3>
              <p className="md:col-span-4 relative text-base md:text-lg text-muted-foreground leading-relaxed md:pt-4">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
